import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';

const DashboardFilterPanel = ({ filters, selectedFilterMode, filterOptions, filterValues, filterLabelKey, filterValueKey, onFilterModeValueChange, onSelectedFilterValuesChange, startDateChange, endDateChange, onSearch }) => {
    
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Start Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>End Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>

                    <Col xs="6" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Filter Mode</Label>
                            <SelectListComponent data={filters} valueKey='id' textField='name' selectValue={selectedFilterMode} onValueChange={onFilterModeValueChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="5">
                        <FormGroup className="mb-4">
                            <Label>Search Box</Label>
                            <SelectListComponent data={filterOptions} multiSelectMode={true} selectValue={filterValues} valueKey={filterLabelKey} textField={filterValueKey} onValueChange={onSelectedFilterValuesChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>Search</Button>
                    </Col>
                </Row>
            </Container>
            
        </Form>
    )
};
export default DashboardFilterPanel;



// WEBPACK FOOTER //
// ./src/views/dashboard/filter-panel.js